/// <amd-module name="Test/Analytics/CardMetricsCommon/CardMetricsChartSeries" />
import * as ChartSeries from "Analytics/Shared/ChartSeries/ChartSeries";
import * as Resources from "Test/Analytics/CardMetricsCommon/Resources";

export class CardMetricsChartSeries extends ChartSeries.ChartSeries {
    public get name(): string {
        return Resources.AnalyticsCardMetricsHeaderText;
    }

    public get color(): string {
        return PipelinePassRateColorPalette;
    }

    public get values(): number[] {
        return this._data;
    }
}

const PipelinePassRateColorPalette = "#8661c5";
